import { render, staticRenderFns } from "./AdventureTour2.vue?vue&type=template&id=3399d6a6&scoped=true&"
import script from "./AdventureTour2.vue?vue&type=script&lang=ts&"
export * from "./AdventureTour2.vue?vue&type=script&lang=ts&"
import style0 from "./AdventureTour2.vue?vue&type=style&index=0&id=3399d6a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3399d6a6",
  null
  
)

export default component.exports